import axios from 'axios';
import { getAuthHeaders } from '../../supabase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

export default async function fetchInfluencerData({ platform, username, type = 'free' }) {
  try {
    const headers = await getAuthHeaders();

    const response = await axios.get(`${BACKEND_URL}/api/infludata`, {
      params: {
        platform,
        username,
        type,
      },
      headers,
    });
    return response.data;
  } catch (error) {
    console.error(`❌ Error fetching ${type} influencer data:`, error.response?.data || error.message);
    throw new Error("Failed to fetch influencer data");
  }
}
